import { CampaignOnboardingBulkUploadModal } from '~components/CampaignOnboarding/CampaignOnboardingBulkUploadModal'
import { useDownloadTemplateCsv } from '~features/campaign/hooks/useDownloadTemplateCsv'
import { useUploadCampaignOnboardingCsv } from '~features/campaign/hooks/useUploadCampaignOnboardingCsv'

export type BulkUploadDistributorModalProps = {
  campaignId: string
  isOpen: boolean
  showDataOverrideWarning: boolean
  onOpen: () => void
  onClose: () => void
}

const MODAL_TITLE = 'Upload multiple distributors'
const MODAL_DESCRIPTION = 'You can upload your distributors with a CSV file. '
const MODAL_INSTRUCTIONS_HEADER = `Fill in CSV template with distributors' details`
const MODAL_INSTRUCTIONS_CONTENT = `Enter the mobile number for each distributor and assign them to specific locations. If you're using the DistributeSG web application, please enter your distributors' email addresses instead.`
const MODAL_DATA_OVERRIDE_WARNING_DESCRIPTION =
  'Uploading a CSV file will override your existing list of distributors.'

export const BulkUploadDistributorModal = ({
  campaignId,
  isOpen,
  showDataOverrideWarning,
  onClose,
}: BulkUploadDistributorModalProps) => {
  const { downloadTemplateCsv } = useDownloadTemplateCsv()
  const { uploadCampaignOnboardingCsv, isUploadingCampaignOnboardingCsv } =
    useUploadCampaignOnboardingCsv()

  return (
    <CampaignOnboardingBulkUploadModal
      title={MODAL_TITLE}
      description={MODAL_DESCRIPTION}
      instructionsHeader={MODAL_INSTRUCTIONS_HEADER}
      instructionsContent={MODAL_INSTRUCTIONS_CONTENT}
      showDataOverrideWarning={showDataOverrideWarning}
      dataOverrideWarningAlertDescription={
        MODAL_DATA_OVERRIDE_WARNING_DESCRIPTION
      }
      isOpen={isOpen}
      onClose={onClose}
      onUpload={(file: File) =>
        uploadCampaignOnboardingCsv({
          file,
          campaignId,
          type: 'upload_distributors',
        })
      }
      isUploading={isUploadingCampaignOnboardingCsv}
      downloadTemplateCsv={() =>
        downloadTemplateCsv({ campaignId, type: 'upload_distributors' })
      }
    />
  )
}
